import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser"

export default class AuthContext {
    azureClientId: string = ''
    azureTenantId: string = ''
    publicClientApplication?: IPublicClientApplication
    account?: AccountInfo
    isInitialized: boolean = false
}
